export const menuItems = [{
        id: 1,
        perm: "view_dashboard",
        label: "Dashboard",
        icon: "bx-home-circle",
        link: "/"
    },
    {
        id: 7,
        perm: "new_sale",
        actionpage: "1",
        label: "menuitems.order.text",
        icon: "bx-cart",
        link: "/sales/order"
    },
    {
        id: 73,
        perm: "agentsale",
        label: "Agent sale",
        icon: "bx-cart",
        link: "/sales/agentsale"
    },
    {
        id: 12,
        perm: "stock_tab",
        label: "menuitems.stock.text",
        icon: "bx-store",
        subItems: [{
                id: 13,
                perm: "view_shop_stock",
                label: "menuitems.stock.list.level",
                link: "/stock/view",
                parentId: 12
            },
            {
                id: 14,
                perm: "add_shop_stock",
                actionpage: "1",
                label: "menuitems.stock.list.addstock",
                link: "/purchase/new",
                parentId: 12
            },
            {
                id: 15,
                perm: "view_spoilt_stock",
                label: "menuitems.stock.list.spoilt",
                link: "/stock/spoilt",
                parentId: 12
            },
            {
                id: 16,
                perm: "view_batch_numbers",
                set: "track_expiries",
                label: "Product Batches",
                link: "/stock/batches",
                parentId: 12
            },
            {
                id: 16,
                perm: "view_short_expiries",
                set: "track_expiries",
                label: "menuitems.stock.list.expiries",
                link: "/stock/shortExpiries",
                parentId: 12
            },
            {
                id: 17,
                perm: "reconcile_shop_stock",
                actionpage: "1",
                label: "menuitems.stock.list.reconcile",
                link: "/stock/reconcile",
                parentId: 12
            },
            {
                id: 18,
                perm: "transfer_stock",
                actionpage: "1",
                label: "menuitems.stock.list.transfer",
                link: "/stock/transfer",
                parentId: 12
            },
            {
                id: 19,
                perm: "view_reconciliation_report",
                label: "menuitems.stock.list.report",
                link: "/reconciliation/report",
                parentId: 12
            },
            {
                id: 20,
                perm: "view_expired_stock",
                set: "track_expiries",
                label: "menuitems.stock.list.expired",
                link: "/stock/expired",
                parentId: 12
            },
            {
                id: 21,
                perm: "internaltransfer_stock",
                actionpage: "1",
                label: "Internal Stock Transfer",
                link: "/stock/intransfer",
                parentId: 12
            },
            {
                id: 22,
                perm: "directtransfer_stock",
                actionpage: "1",
                label: "Direct Stock Transfer",
                link: "/stock/transfer/direct",
                parentId: 12
            },
        ]
    },
    {
        id: 62,
        perm: "agentstock_tab",
        label: "Agents Stock",
        icon: "bx-store",
        subItems: [{
                id: 63,
                perm: "view_agentstock",
                label: "Stock",
                link: "/agent_stock/stock",
                parentId: 62
            },
            {
                id: 64,
                perm: "view_agentstock",
                label: "Agent stock value",
                link: "/agent_stock/stockvalue",
                parentId: 62
            },
            {
                id: 65,
                perm: "record_disbursements",
                label: "Disburse",
                link: "/agent_stock/disburse",
                parentId: 62
            },
            {
                id: 66,
                perm: "manage_disbursements",
                label: "Disbursements",
                link: "/agent_stock/disbursements",
                parentId: 62
            },
            {
                id: 67,
                perm: "reconcile_agentstock",
                label: "Reconcile agent stock",
                link: "/agent_stock/reconcile_stock",
                parentId: 62
            },
            {
                id: 68,
                perm: "view_agentstock_reconcilation",
                label: "menuitems.stock.list.report",
                link: "/agent_stock/reconcilation_report",
                parentId: 62
            },
            {
                id: 69,
                perm: "manage_agent_damages",
                label: "Damages",
                link: "/agent_stock/damages",
                parentId: 62
            },
            {
                id: 70,
                perm: "manage_agentstock_returns",
                label: "Return Stock",
                link: "/agent_stock/return_stock",
                parentId: 62
            },
            {
                id: 71,
                perm: "view_agentstock_returns",
                label: "Agent stock returns",
                link: "/agent_stock/stock_returns",
                parentId: 62
            },

        ]
    },
    {
        id: 52,
        perm: "agentsale",
        label: "Missed Customers",
        icon: "bx-user",
        link: "/missed_customers"
    },
    {
        id: 53,
        perm: "store_tab",
        label: "menuitems.store.text",
        icon: "bx-store",
        subItems: [{
                id: 54,
                perm: "view_store_stock",
                label: "menuitems.store.list.level",
                link: "/store/view",
                parentId: 53
            },
            {
                id: 55,
                perm: "add_store_stock",
                actionpage: "1",
                label: "menuitems.store.list.addstock",
                link: "/store/add",
                parentId: 53
            },
            {
                id: 56,
                perm: "reconcile_store_stock",
                actionpage: "1",
                label: "menuitems.store.list.reconcile",
                link: "/store/reconcile",
                parentId: 53
            },

            {
                id: 57,
                perm: "view_purchases_report",
                label: "menuitems.store.list.purchaseReport",
                link: "/store/purchases",
                parentId: 53
            }
        ]
    },
    {
        id: 29,
        perm: "products_tab",
        label: "menuitems.products.text",
        icon: "bx-grid",
        subItems: [{
                id: 28,
                perm: "add_products",
                actionpage: "1",
                label: "Add Products",
                link: "/products/add_product",
                parentId: 29
            },
            {
                id: 27,
                perm: "view_products",
                label: "Search Products",
                link: "/products/search_products",
                parentId: 29
            },
            {
                id: 30,
                perm: "view_products",
                label: "menuitems.products.list.view",
                link: "/products/view",
                parentId: 29
            },
            {
                id: 31,
                perm: "view_product_categories",
                label: "menuitems.products.list.categories",
                link: "/categories/view",
                parentId: 29
            },
            {
                id: 32,
                perm: "view_business_products",
                label: "menuitems.products.list.business",
                parentId: 29,
                link: "/business/products",
            },
            {
                id: 33,
                perm: "view_units",
                label: "menuitems.products.list.units",
                parentId: 29,
                link: "/units/view",
            },
            {
                id: 34,
                perm: "view_product_units",
                set: "allow_multiple_units",
                label: "menuitems.products.list.punits",
                parentId: 29,
                link: "/products/units",
            },
            {
                id: 35,
                perm: "view_services",
                label: "menuitems.products.list.services",
                parentId: 29,
                link: "/services/view",
            }
        ]
    },
    {
        id: 36,
        perm: "consumables_tab",
        label: "Production Unit",
        icon: "bx-grid",
        subItems: [{
                id: 9,
                label: "Items",
                subItems: [{
                        id: 37,
                        perm: "add_consumable_items",
                        actionpage: "1",
                        label: "Add Items",
                        link: "/consumables/add_item",
                        parentId: 9
                    },
                    {
                        id: 11,
                        perm: "add_consumable_items",
                        actionpage: "1",
                        label: "Add Item Units",
                        link: "/consumables/item_units",
                        parentId: 9
                    },
                ],
                parentId: 36
            },
            {
                id: 89,
                perm: "using_consumables",
                actionpage: "1",
                label: "Batch Input",
                parentId: 36,
                link: "/production/cart",
            },
            {
                id: 8,
                perm: "stocking_consumables",
                label: "Stock",
                subItems: [{
                        id: 6,
                        perm: "stocking_report",
                        label: "Current Stock",
                        link: "/consumables/currentstock",
                        parentId: 8
                    },
                    {
                        id: 38,
                        perm: "stocking_consumables",
                        actionpage: "1",
                        label: "Add to Stock",
                        link: "/consumables/stocking",
                        parentId: 8
                    },
                    {
                        id: 58,
                        perm: "reconcile_consumables_stock",
                        actionpage: "1",
                        label: "menuitems.stock.list.reconcile",
                        link: "/consumables/reconcile",
                        parentId: 8
                    },
                    {
                        id: 59,
                        perm: "view_spoilt_consumables",
                        label: "menuitems.stock.list.spoilt",
                        link: "/consumables/spoilt",
                        parentId: 8
                    },
                ],
                parentId: 36
            },
            {
                id: 42,
                perm: "usage_report",
                label: "Production Batches",
                parentId: 36,
                link: "/production/batches",
            },
            {
                id: 41,
                perm: "stocking_report",
                label: "Purchases Report",
                parentId: 36,
                link: "/consumables/stocking_report",
            },
            {
                id: 42,
                perm: "usage_report",
                label: "Usage Report",
                parentId: 36,
                link: "/consumables/usage_report",
            },
            {
                id: 43,
                perm: "stocking_consumables",
                label: "Creditors report",
                parentId: 36,
                link: "/consumables/creditors",
            },
        ]
    },
    {
        id: 37,
        perm: "expenses_tab",
        label: "menuitems.expenses.text",
        icon: "bx-food-menu",
        subItems: [{
                id: 72,
                perm: "view_agentexpenses",
                label: "Agent Expenses",
                link: "/expenses/agentexpenses",
                parentId: 37
            },
            {
                id: 3712,
                perm: "view_expenses",
                actionpage: "1",
                label: "Record Expense",
                link: "/expenses/record",
                parentId: 37
            },
            {
                id: 372,
                perm: "view_expenses",
                actionpage: "1",
                label: "Creditors ",
                link: "/expenses/creditors",
                parentId: 37
            },
            {
                id: 38,
                perm: "view_expenses",
                actionpage: "1",
                label: "Expenses",
                link: "/expenses/view",
                parentId: 37
            },
            {
                id: 39,
                perm: "view_expense_categories",
                actionpage: "1",
                label: "menuitems.expenses.list.categories",
                link: "/expenses/categories",
                parentId: 37
            },
            {
                id: 40,
                perm: "view_expenses_report",
                label: "menuitems.expenses.list.report",
                link: "/expenses/report",
                parentId: 37
            },
        ]
    },
    {
        id: 46,
        perm: "reports_tab",
        actionpage: "1",
        label: "menuitems.reports.text",
        icon: "bxs-folder-open",
        subItems: [{
                id: 47,
                perm: "view_sales_report",
                label: "menuitems.reports.list.sreport",
                link: "/sales",
                parentId: 46
            },
            {
                id: 47,
                perm: "view_payments_report",
                label: "Payments Report",
                link: "/payments",
                parentId: 46
            },
            {
                id: 47,
                perm: "view_purchase_payments_report",
                label: "Purchase Payments",
                link: "/purchase_payments",
                parentId: 46
            },
            {
                id: 48,
                perm: "view_purchases_report",
                label: "menuitems.reports.list.preport",
                link: "/shop/purchases",
                parentId: 46
            },
            {
                id: 49,
                perm: "view_debtors_report",
                label: "menuitems.reports.list.debtor",
                link: "/sales/debtors",
                parentId: 46
            },
            {
                id: 50,
                perm: "view_creditors_report",
                label: "Creditors Report",
                link: "/purchases/creditors",
                parentId: 46
            },
            {
                id: 50,
                perm: "view_stock_transfers",
                label: "menuitems.stock.list.transfers",
                link: "/stock/transfers",
                parentId: 46
            },
            {
                id: 54,
                perm: "view_held_sales",
                label: "menuitems.reports.list.held",
                link: "/sales/held",
                parentId: 46
            },
            {
                id: 60,
                perm: "view_sales_report",
                label: "Discounts Allowed",
                link: "/sales/discounts",
                parentId: 46
            },
            {
                id: 61,
                perm: "view_sales_report",
                set: "track_untake_orders",
                label: "Untaken Orders",
                link: "/reports/untaken_orders",
                parentId: 46
            }
        ]
    },
    {
        id: 47,
        perm: "reports_tab",
        actionpage: "1",
        label: "Vehicles",
        icon: "bxs-folder-open",
        subItems: [{
                id: 471,
                perm: "view_sales_report",
                label: "Vehicles",
                link: "/vehicles",
                parentId: 46
            },
            {
                id: 472,
                perm: "view_sales_report",
                label: "Vehicle Expenses",
                link: "/vehicle/expenses",
                parentId: 46
            },
            {
                id: 473,
                perm: "view_sales_report",
                label: "Vehicle Expenses Report",
                link: "/vehicle/expenses/report",
                parentId: 46
            },
        ]
    },
    {
        id: 51,
        perm: "view_messages",
        actionpage: "1",
        label: "menuitems.message.text",
        icon: "bx-paper-plane",
        link: "/messages"
    },

];